<template>
  <b-container v-if="page === 'LIST_TEMPLATE'" data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          {{
            $t(
              "public.views.Pages.Professional.Organization.Survey.titleTemplates"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="checkPermissionProfessional('SURVEY', ['CREATE']) && checkPermissionProfessional('SURVEY', ['EDIT'])" class="mr-2" style="right" variant="success"
          @click="viewCreateTemplate">{{
            $t("public.views.Pages.Professional.Organization.Survey.btnCreate")
          }}
        </b-button>
      </template>
      <template v-if="checkPermissionProfessional('SURVEY', ['READ'])" v-slot:body>
        <div v-if="templates && templates.length !== 0">
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
              <template slot="label">{{
                $t("public.views.Pages.Professional.Organization.Survey.search")
              }}
              </template>
            </v-text-field>
          </v-card-title>

          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headers" :items="templates" :items-per-page="10" :search="search" item-key="uuid">
            <template v-slot:item.engine="{ item }">
              <div v-if="item.engine === 'CALCULATED_CORE'">CORE</div>
              <div v-else-if="item.engine === 'NORMAL'">NORMAL</div>
              <div v-else>NORMAL</div>
            </template>
            <template v-slot:item.uuid="{ item }">
              <div class="div-table-data">
                <button v-if="checkPermissionProfessional('SURVEY',  ['EDIT'])" id="btnUpdate" class="item"
                  v-on:click="viewUpdateTemplate(item.uuid)">
                  <i class="ri-refresh-line"></i>
                </button>
                <b-popover v-if="checkPermissionProfessional('SURVEY', ['EDIT'])" placement="botton" target="btnUpdate"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Organization.Survey.organization.btnUpdate"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="checkPermissionProfessional('SURVEY', ['CREATE']) && checkPermissionProfessional('SURVEY', ['EDIT'])" id="btnClone" class="item"
                  v-on:click="viewCloneTemplate(item.uuid)">
                  <i class="ri-file-copy-line"></i>
                </button>
                <b-popover v-if="checkPermissionProfessional('SURVEY', ['CREATE']) && checkPermissionProfessional('SURVEY', ['EDIT'])" placement="botton" target="btnClone"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Organization.Survey.organization.btnClone"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="checkPermissionProfessional('SURVEY', ['DELETE'])" id="btnDelete" class="item"
                  v-on:click="viewDeleteTemplate(item.uuid)">
                  <i class="ri-delete-bin-line"></i>
                </button>
                <b-popover v-if="checkPermissionProfessional('SURVEY',  ['DELETE'])" placement="botton" target="btnDelete"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Organization.Survey.organization.btnDelete"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="checkPermissionProfessional('SURVEY', ['READ'])" id="btnPreview" class="item"
                  v-on:click="previewTemplate(item.uuid)">
                  <i class="ri-eye-line"></i>
                </button>
                <b-popover v-if="checkPermissionProfessional('SURVEY', ['READ'])" placement="botton" target="btnPreview"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Organization.Survey.organization.btnPreview"
                    )
                  }}
                  </template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <b-alert show variant="primary">
            {{
              $t(
                "public.views.Pages.Professional.Organization.Survey.organization.alert.empty"
              )
            }}
          </b-alert>
        </div>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          {{ $t("public.views.Pages.Professional.Organization.Survey.title") }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="!showProfessional" style="right" variant="primary" @click="backProfessionals">{{
          $t("public.views.Pages.Professional.Organization.Survey.btnBack")
        }}
        </b-button>

        <b-button v-if="
          checkPermissionProfessional('SURVEY', ['CREATE']) &&
          templates.length !== 0
        " class="mr-2" style="right" variant="success" @click="viewStoreSurvey">Enviar
        </b-button>
        <b-button v-if="
          surveys &&
          surveys.length !== 0 && !organization.isGalatea &&
          checkPermissionProfessional('SURVEY', ['READ'])
        " class="mr-2 btn-flat" style="right" variant="primary" @click="openDownload">Descargar
        </b-button>
        <b-button v-if="
          surveys &&
          surveys.length !== 0 && organization.isGalatea &&
          checkPermissionProfessional('SURVEY', ['READ'])
        " class="mr-2 btn-flat" style="right" variant="primary" @click="openDownloadGalatea">Descargar
        </b-button>
        <b-button v-if="
          organization &&
          organization.isGalatea &&
          surveys &&
          surveys.length !== 0 &&
          checkPermissionProfessional('SURVEY', ['READ'])
        " class="mr-2 btn-flat" style="right" variant="primary" @click="openDownloadComparativaGalatatea">Descargar
          comparativa
        </b-button>
      </template>
      <template v-if="showProfessional" v-slot:body>
        <div>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line></v-text-field>
            <template slot="label">{{
              $t("public.views.Pages.Professional.Organization.Survey.search")
            }}
            </template>
          </v-card-title>
          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headersSurveyOrganization" :items="surveys" :search="search" item-key="id">
            <template v-slot:item.template="{ item }">
              <div v-if="item.template">
                {{ item.template.name }}
              </div>
              <div v-else>Error</div>
            </template>
            <template v-slot:item.recurrentDays="{ item }">
              <div v-if="item.recurrentDays">
                Recurrente ({{ item.recurrentDays }} días)
              </div>
              <div v-else>No recurrente</div>
            </template>
            <template v-slot:item.programmaticAt="{ item }">
              <div v-if="item.programmaticAt">
                {{ item.programmaticAt | adjustToTimezone("DD/MM/YYYY") }}
              </div>
              <div v-else>No programado</div>
            </template>
            <template v-slot:item.status="{ item }">
              <div v-if="item.status === 'SEND'">Enviado</div>
              <div v-else>Pendiente</div>
            </template>
            <template v-slot:item.type="{ item }">
              <div v-if="item.type === 'NORMAL'">Normal</div>
              <div v-else>Calculada</div>
            </template>
            <template v-slot:item.id="{ item }">
              <div class="div-table-data">
                <button :id="'btnSee' + item.id" class="item" v-on:click="getSurveyStore(item)">
                  <i class="ri-eye-line"></i>
                </button>
                <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                  <template #title>Ver envío</template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
      <template v-else v-slot:body>
        <div class="text-right"></div>
        <div>
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line></v-text-field>
            <template slot="label">{{
              $t("public.views.Pages.Professional.Organization.Survey.search")
              }}
            </template>
          </v-card-title>
          <v-data-table :footer-props="{
                      showFirstLastPage: true,
                      firstIcon: 'fas fa-arrow-left',
                      lastIcon: 'fas fa-arrow-right',
                      prevIcon: 'fas fa-minus',
                      nextIcon: 'fas fa-plus',
                      'items-per-page-options': [10, 25, 50],
                    }" :headers="headersSurvey" :items="surveys" :search="search" item-key="id">
            <template v-slot:item.date="{ item }">
              <div v-if="item.date">
                {{ item.date | adjustToTimezone("DD/MM/YYYY HH:mm") }}
              </div>
            </template>
            <template v-slot:item.id="{ item }">
              <div class="div-table-data">
                <button :id="'btnSee' + item.id" class="item" v-on:click="showSurveyQuestion(item.surveyQuestions)">
                  <i class="ri-eye-line"></i>
                </button>
                <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                  <template #title>{{
                    $t(
                    "public.views.Pages.Professional.Organization.Survey.btnSee"
                    )
                    }}
                  </template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
      <b-modal id="modal-survey-store-details" centered hide-footer size="lg">
        <template #modal-title>Información del envío de la encuesta</template>
        <b-row v-if="surveyStore">Nombre: {{ surveyStore.name }}</b-row>
        <b-row v-if="surveyStore">Respuestas:</b-row>
        <div v-if="surveyStore">
          <b-content>
            <b-row v-for="(survey, index) in surveyStore.surveys" v-bind:key="index">
              <div>{{ survey.date | adjustToTimezone("DD/MM/YYYY") }} -</div>
              <ul v-for="(question, index) in survey.surveyQuestions" v-bind:key="index">
                <li>{{ question.question }} : {{ question.value }}</li>
              </ul>
            </b-row>
          </b-content>
        </div>
      </b-modal>
      <b-modal id="modal-survey-question" centered hide-footer size="lg">
        <template #modal-title>{{
          $t(
            "public.views.Pages.Professional.Organization.Survey.modalSurveyQuestion.title"
          )
        }}
        </template>
        <template #modal-ok >{{
          $t(
            "public.views.Pages.Professional.Organization.Survey.modalSurveyQuestion.save"
          )
        }}
        </template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Organization.Survey.modalSurveyQuestion.cancel"
          )
        }}
        </template>
        <v-data-table :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-arrow-left',
          lastIcon: 'fas fa-arrow-right',
          prevIcon: 'fas fa-minus',
          nextIcon: 'fas fa-plus',
          'items-per-page-options': [10, 25, 50],
        }" :headers="headersSurveyQuestion" :items="surveyQuestions" :search="search" item-key="id">
        </v-data-table>
      </b-modal>
      <b-modal id="modal-survey-store" centered @ok="saveFormStore">
        <template #modal-title>
          <span v-if="storeSurvey.now">Enviar</span><span v-else>Programar</span> encuesta
        </template>
        <template #modal-cancel>{{
          $t("public.views.Pages.Alert.modalCreate.btnClose")
        }}
        </template>
        <template #modal-ok>
          <span v-if="storeSurvey.now">Enviar</span><span v-else>Programar</span>
        </template>
        <b-form-group label-for="name">
          <template slot="label"> Nombre: *</template>
          <b-form-input v-model="storeSurvey.name"></b-form-input>
          <ul v-if="isFormStoreNameErrors">
            <li v-for="(error, index) in validatorStep2.getErrors(
              'storeSurvey.name'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <b-form-group label-for="template-send">
          <template slot="label"> Plantilla: *</template>

          <multiselect v-model="storeSurvey.template" :clear-on-select="false" :close-on-select="false"
            :disabled="disabled" :options="templatesSelect" :preselect-first="false" :preserve-search="true" label="text"
            track-by="value" v-bind:deselectGroupLabel="
              $t(
                'public.views.Pages.Professional.Organization.Survey.multiselect-list.deselectGroupLabel'
              )
            " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Organization.Survey.multiselect-list.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Organization.Survey.multiselect-list.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Organization.Survey.multiselect-list.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Organization.Survey.multiselect-list.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Organization.Survey.multiselect-list.selectedLabel'
  )
">
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </b-list-group-item>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                class="multiselect__single">{{ values.length }}
                {{
                  $t(
                    "public.views.Pages.Professional.Organization.Survey.multiselect-list.seletedTemplate"
                  )
                }}</span></template>
            <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                  class="option__title">
                  <span class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
                </span></span></template>
          </multiselect>

          <ul v-if="isFormStoreTemplateErrors">
            <li v-for="(error, index) in validatorStep2.getErrors(
              'storeSurvey.template'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <b-form-group label-for="name">
          <template slot="label">
            {{ $t("public.views.Pages.Alert.modalCreate.list") }}: *
          </template>

          <multiselect v-model="storeSurvey.listPatients" :clear-on-select="false" :close-on-select="false"
            :disabled="disabled" :multiple="true" :options="listPatientsSelect" :preselect-first="false"
            :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="
              $t('public.views.Pages.Alert.multiselect-list.deselectGroupLabel')
            " v-bind:deselectLabel="
  $t('public.views.Pages.Alert.multiselect-list.deselectLabel')
" v-bind:placeholder="
  $t('public.views.Pages.Alert.multiselect-list.placeholder')
" v-bind:selectGroupLabel="
  $t('public.views.Pages.Alert.multiselect-list.selectGroupLabel')
" v-bind:selectLabel="
  $t('public.views.Pages.Alert.multiselect-list.selectLabel')
" v-bind:selectedLabel="
  $t('public.views.Pages.Alert.multiselect-list.selectedLabel')
">
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </b-list-group-item>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                class="multiselect__single">{{ values.length }}
                {{
                  $t(
                    "public.views.Pages.Alert.multiselect-list.selectedPatients"
                  )
                }}</span></template>
            <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                  class="option__title">
                  <span class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
                </span></span></template>
          </multiselect>
        </b-form-group>

        <b-form-group label-for="patient">
          <template slot="label">
            {{ $t("public.views.Pages.Alert.modalCreate.patients") }}:
            *
          </template>

          <multiselect v-model="storeSurvey.patients" :clear-on-select="false" :close-on-select="false"
            :loading="isLoadingPatients" :multiple="true" :options="patientsSelect" :preselect-first="false"
            :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="
              $t(
                'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectGroupLabel'
              )
            " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Sessions.multiselect.selectedLabel'
  )
" @search-change="getAllPatients">
            <template slot="noResult">
              {{ $t("generic.noResults") }}
            </template>
            <template slot="noOptions">
              {{ $t("generic.min3") }}
            </template>
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </b-list-group-item>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                class="multiselect__single">{{
                  values.length
                }}{{
  $t(
    "public.views.Pages.Professional.Admin.Sessions.selectedContacts"
  )
}}</span></template>
          </multiselect>

          <ul v-if="isFormStorePatientsErrors">
            <li v-for="(error, index) in validatorStep2.getErrors(
              'storeSurvey.patients'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <b-form-group label-for="content">
          <template slot="label">Cabezera email: *</template>
          <ckeditor v-model="storeSurvey.content" :config="configCK" :disabled="disabled" type="classic"></ckeditor>
          <ul v-if="isFormStoreContentErrors">
            <li v-for="(error, index) in validatorStep2.getErrors(
              'storeSurvey.content'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>

        <!--<b-form-group label-for="active">
          <template slot="label">¿Enviar ahora?:</template>
          <b-form-checkbox
            switch
            v-model="storeSurvey.now"
            id="now"
            size="lg"
          ></b-form-checkbox>-->
        <div v-if="!storeSurvey.now">
          <b-form-group label-for="programaticAt">
            <template slot="label">Programar envío (Por fecha):</template>
            <date-picker v-model="storeSurvey.date" :format="myFormat" :formatter="momentFormat"
              type="date"></date-picker>
          </b-form-group>
        </div>
        <!--<b-form-group label-for="active">
          <template slot="label">¿Quieres recurrencia?:</template>
          <b-form-checkbox
            switch
            v-model="storeSurvey.recurrent"
            id="recurrent"
            size="lg"
          ></b-form-checkbox>
        </b-form-group>-->
        <div v-if="storeSurvey.recurrent">
          <b-form-group label-for="programaticAt">
            <template slot="label">¿Cada cuanto quieres enviarla? (En días):
            </template>
            <b-input v-model="storeSurvey.recurrentDays" max="365" min="0" type="number"></b-input>
            <ul v-if="isFormStoreRecurrentDaysErrors">
              <li v-for="(error, index) in validatorStep2.getErrors(
                'storeSurvey.recurrentDays'
              )" v-bind:key="index" class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </div>
      </b-modal>
      <b-modal id="modal-download-comparativa-galatatea" centered @ok="downloadComparativeGalatea">
        <template #modal-title> Descargar comparativa encuestas</template>
        <template #modal-ok>Descargar</template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Organization.Professionals.modalDelete.btnClose"
          )
        }}
        </template>
        <b-form-group label-for="dateStart">
          <template slot="label">Fecha inicio: *</template>
          <date-picker v-model="dateStartDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
            type="date"></date-picker>
        </b-form-group>
        <b-form-group label-for="dateEnd">
          <template slot="label">Fecha fin: *</template>
          <date-picker v-model="dateEndDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
            type="date"></date-picker>
        </b-form-group>
      </b-modal>
      <b-modal id="modal-download" centered @ok="download">
        <template #modal-title> Descargar encuestas</template>
        <template #modal-ok>Descargar</template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Organization.Professionals.modalDelete.btnClose"
          )
        }}
        </template>
        <b-form-group label-for="dateStart">
          <template slot="label">Fecha inicio: *</template>
          <date-picker v-model="dateStartDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
            type="date"></date-picker>
        </b-form-group>
        <b-form-group label-for="dateEnd">
          <template slot="label">Fecha fin: *</template>
          <date-picker v-model="dateEndDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
            type="date"></date-picker>
        </b-form-group>
      </b-modal>
      <b-modal id="modal-download-galatea" centered @ok="downloadGalatea">
        <template #modal-title> Descargar encuestas</template>
        <template #modal-ok>Descargar</template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Organization.Professionals.modalDelete.btnClose"
          )
        }}
        </template>
        <b-form-group label-for="dateStart">
          <template slot="label">Fecha inicio: *</template>
          <date-picker v-model="dateStartDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
            type="date"></date-picker>
        </b-form-group>
        <b-form-group label-for="dateEnd">
          <template slot="label">Fecha fin: *</template>
          <date-picker v-model="dateEndDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
            type="date"></date-picker>
        </b-form-group>
      </b-modal>
    </iq-card>
  </b-container>
  <b-container v-else data-app fluid>
    <div class="iq-card">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title title-typography-color">
            <i class="fas fa-file"></i>
            {{
              $t(
                "public.views.Pages.Professional.Organization.Survey.organization.titleInformation"
              )
            }}
          </h4>
        </div>
        <div class="iq-card-header-toolbar d-flex align-items-center">
          <b-button ref="btnShowNewContact" class="mr-2" style="right" variant="primary" @click="listTemplate">{{
            $t(
              "public.views.Pages.Professional.Organization.Survey.organization.btnBack"
            )
          }}
          </b-button>
          <b-button ref="btnShowNewContact" class="mr-2"
            style="right" variant="success" @click="saveForm">
            <div v-if="action === 'CLONE'">
              {{
                $t(
                  "public.views.Pages.Professional.Organization.Survey.organization.btnCloneCreate"
                )
              }}
            </div>
            <div v-else>
              {{
                $t(
                  "public.views.Pages.Professional.Organization.Survey.organization.btnSave"
                )
              }}
            </div>
          </b-button>
        </div>
      </div>
      <div class="card-body iq-card-body">
        <b-form-group label-for="name">
          <template slot="label">{{
            $t(
              "public.views.Pages.Professional.Organization.Survey.organization.name"
            )
          }}: *
          </template>
          <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
            'text-danger': isFormNameErrors,
            'is-invalid': isFormNameErrors,
          }" @blur="checkName(name)"></b-form-input>
          <ul v-if="isFormNameErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="engine">
          <template slot="label">{{
            $t(
              "public.views.Pages.Professional.Organization.Survey.organization.engine"
            )
          }}: *
          </template>
          <b-select id="engine" v-model="engine" :disabled="disabled" :options="engineSelect" type="text"
            @change="changeQuestionForEngine"></b-select>
        </b-form-group>
      </div>
    </div>
    <div class="iq-card">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title title-typography-color">
            <i class="fas fa-folder-plus"></i>
            {{
              $t(
                "public.views.Pages.Professional.Organization.Survey.organization.title"
              )
            }}
          </h4>
        </div>
      </div>
      <div class="card-body iq-card-body">
        <tab-nav :tabs="true">
          <tab-nav-items v-for="(option, index) in tabs" :id="'tab-nav-' + index" :key="index" :active="index < 1"
            :ariaSelected="true" :href="'#tab-' + index" role="tab">
            <template v-slot:title>
              <b-form-input v-model="option.name"></b-form-input>
            </template>
          </tab-nav-items>
        </tab-nav>
        <tab-content>
          <tab-content-item v-for="(option, index) in tabs" :id="'tab-' + index" :key="index" :active="index < 1">
            <div class="test-survey-builder">
              <QuestionsView :questions="option.questionsList" :readOnly="false" />
              <div v-if="addQuestion">
                <SurveyEngineBuilder v-if="engine !== 'CALCULATED_CORE'" :options="sampleQuestion" :tab="index" />
                <SurveyBuilder v-else :options="sampleQuestion" :tab="index" />
              </div>
              <div class="text-right">
                <b-button v-if="checkPermissionProfessional('SURVEY', ['READ'])" variant="success"
                  v-on:click="addNewQuestion()">
                  {{
                    $t(
                      "public.views.Pages.Professional.Organization.Survey.organization.btnNewQuestion"
                    )
                  }}
                </b-button>
              </div>
            </div>
          </tab-content-item>
        </tab-content>
      </div>
    </div>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";
import { mapActions, mapGetters } from "vuex";

import validator from "vue-m-validator";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import Survey from "../../../../json/Survey";
import SurveyEngine from "../../../../json/SurveyEngine";

import SurveyBuilder from "../../../../components/survey/SurveyBuilderSurvey";
import SurveyEngineBuilder from "../../../../components/survey/SurveyBuilderEngineSurvey";
import QuestionsView from "../../../../components/survey/QuestionsView";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import moment from "moment";
import { saveAs } from "file-saver";

import organizationService from "../../../../services/organization";
import professionalService from "../../../../services/professional";
import questionaryService from "../../../../services/questionary";
import surveyService from "../../../../services/survey";
import utilsService from "../../../../services/utils";
import patientService from "../../../../services/patient";
import listPatientService from "../../../../services/listPatient";

export default {
  name: "Survey",
  computed: {
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
  },
  mounted() {
    xray.index();
    this.getAllByOrganizationStore();
    this.getAllTemplates();
    this.initComponetsTemplates();
    this.getAllLists();
    this.getOrganization();

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SURVEY", info: "" });
  },
  computed: {
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormContentErrors() {
      let errors = this.validatorStep1.getErrors("content");
      return errors && errors.length > 0;
    },
    isFormPatientsErrors() {
      let errors = this.validatorStep1.getErrors("patients");
      return errors && errors.length > 0;
    },
    //Survey store
    isFormStoreNameErrors() {
      let errors = this.validatorStep2.getErrors("storeSurvey.name");
      return errors && errors.length > 0;
    },
    isFormStorePatientsErrors() {
      let errors = this.validatorStep2.getErrors("storeSurvey.patients");
      return errors && errors.length > 0;
    },
    isFormStoreTemplateErrors() {
      let errors = this.validatorStep2.getErrors("storeSurvey.template");
      return errors && errors.length > 0;
    },
    isFormStoreRecurrentDaysErrors() {
      let errors = this.validatorStep2.getErrors("storeSurvey.recurrentDays");
      return errors && errors.length > 0;
    },
    isFormStoreContentErrors() {
      let errors = this.validatorStep2.getErrors("storeSurvey.content");
      return errors && errors.length > 0;
    },
  },
  methods: {
    async getOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(this.organizationId),
        (response) => {
          if (response) {
            self.organization = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId
            })
          });
        },
        " "
      );
    },
    downloadComparativeGalatea() {
      let data = {
        start: moment(this.dateStartDownload).format("YYYY-MM-DD"),
        end: moment(this.dateEndDownload).format("YYYY-MM-DD"),
      };

      this.$awn.asyncBlock(
        surveyService.getAllExcelByOrganizationComparativeGalatea(
          localStorage.getItem("organizationId"),
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY_EXCEL", info: "" });
            saveAs(response.data, "surveys.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.getAllExcelByOrganizationComparativeGalatea",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"),
              data: data
            })
          });
        },
        " "
      );
    },
    download() {
      let data = {
        start: moment(this.dateStartDownload).format("YYYY-MM-DD"),
        end: moment(this.dateEndDownload).format("YYYY-MM-DD"),
      };

      this.$awn.asyncBlock(
        surveyService.getAllExcelByOrganization(
          localStorage.getItem("organizationId"),
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY_EXCEL", info: "" });
            saveAs(response.data, "surveys.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "urveyService.getAllExcelByOrganization",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"),
              data: data
            })
          });
        },
        " "
      );
    },
    downloadGalatea() {
      let data = {
        start: moment(this.dateStartDownload).format("YYYY-MM-DD"),
        end: moment(this.dateEndDownload).format("YYYY-MM-DD"),
      };

      this.$awn.asyncBlock(
        surveyService.getAllExcelByOrganizationGalatea(
          localStorage.getItem("organizationId"),
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY_EXCEL", info: "" });
            saveAs(response.data, "surveys.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "urveyService.getAllExcelByOrganization",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"),
              data: data
            })
          });
        },
        " "
      );
    },
    openDownload() {
      this.$bvModal.show("modal-download");
    },
    openDownloadGalatea() {
      this.$bvModal.show("modal-download-galatea");
    },
    openDownloadComparativaGalatatea() {
      this.$bvModal.show("modal-download-comparativa-galatatea");
    },
    async changeQuestionForEngine() {
      if (this.engine === "CALCULATED_CORE") {
      }
    },
    async getAllLists() {
      let self = this;

      listPatientService
        .getAllPagination(0, 1000)
        .then((response) => {
          if (response) {
            let combo = [];
            response.data.content.forEach(function (item) {
              let data = {
                value: item.id,
                text: item.name + " (" + item.patients.length + " pacientes)  ",
              };
              combo.push(data);
            });
            self.listPatientsSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "listPatientService.getAllPagination",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    async getAllPatients(query) {
      let self = this;

      if (query.length > 2) {
        this.isLoadingPatients = true;
        patientService
          .getAll(query)
          .then((response) => {
            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                avatar: item.avatarUrl
                  ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                  : "",
                uuid: item.uuid,
                value: item.id,
                text:
                  item.name + " " + item.lastname + " (" + item.document + ") ",
              };
              combo.push(data);
            });
            self.patientsSelect = combo;
            self.isLoadingPatients = false;
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAll",
              module: "view-pages-professional-contact-survey",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                query: query
              })
            });
            self.isLoadingPatients = false;
          });
      }
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    //Get templates survey
    checkFormStep1() {
      this.checkName(this.name);
    },
    async initComponetsTemplates() {
      let self = this;
      this.$root.$on("change-colums", (columns) => {
        self.numCol = columns;
      });
      this.$root.$on("add-update-question", (q, tab) => {
        self.updateQuestionsList(q, tab);
      });
    },
    updateQuestionsList(question, tab) {
      let sequenceIndex = this.tabs[tab].questionsList.length + 1;
      question.sequence = sequenceIndex;
      const questionIndex = this.tabs[tab].questionsList.findIndex(
        (x) => x.uuid === question.uuid
      );
      if (questionIndex >= 0) {
        this.tabs[tab].questionsList.splice(questionIndex, 1, question);
      } else {
        this.tabs[tab].questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit("selected-question", null);
    },
    addNewQuestion() {
      this.sampleQuestion = JSON.parse(JSON.stringify(Survey));
      this.sampleQuestion.uuid = this.getGUID();
      this.addQuestion = true;
    },
    getGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
    },
    getTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.findQuestionary(this.professional, uuid),
        (response) => {
          if (response) {
            self.uuid = response.data.uuid;
            self.selected =
              response.data.selected === null ? false : response.data.selected;
            self.name = response.data.name;
            self.numCol = response.data.numCol;
            self.tabs = response.data.tabs;
            self.engine = response.data.engine;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.findQuestionary",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional, uuid: uuid
            })
          });
        },
        " "
      );
    },
    //survey
    checkFormStepStore() {
      //Validation form modal store survey
      this.checkStoreName(this.storeSurvey.name);
      // this.checkStorePatient("");
      // this.checkStoreTemplate(this.storeSurvey.template);
      // this.checkStoreRecurrentDays(this.storeSurvey.recurrentDays);
      // this.checkStoreContent(this.storeSurvey.content);
    },
    getSurveyStore(surveyStore) {
      this.$router.push({
        name: "auth.professional.contact.surveys",
        query: { surveyStoreId: surveyStore.id },
      });
    },
    createStore() {
      let self = this;

      let patients = [];

      if (this.storeSurvey.patients) {
        this.storeSurvey.patients.forEach((item) => {
          patients.push(item.value);
        });
      }

      let listPatients = [];

      if (this.storeSurvey.listPatients) {
        this.storeSurvey.listPatients.forEach((item) => {
          listPatients.push(item.value);
        });
      }

      let data = {
        name: this.storeSurvey.name,
        patientIds: patients,
        listPatientIds: listPatients,
        templateUuid:
          this.storeSurvey.template !== undefined
            ? this.storeSurvey.template.value
            : "",
        programmaticAt:
          this.storeSurvey.date === undefined ? null : this.storeSurvey.date,
        recurrentDays: this.storeSurvey.recurrentDays,
        type: "NORMAL",
        content: this.storeSurvey.content,
      };

      this.$awn.asyncBlock(
        surveyService.createStore(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.$bvModal.hide("modal-survey-store");
            self.getAllByOrganizationStore();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descSaveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.createStore",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    updateStore() {
      let self = this;

      let data = {
        uuid: this.uuid,
        name: this.name,
        selected: this.selected,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        questionaryService.updateTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descRefreshTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.updateTemplate",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    saveFormStore(evt) {
      evt.preventDefault();

      this.checkFormStepStore();
      if (this.validatorStep2.errors.length === 0) {
        if (this.action === "CREATE") {
          this.createStore();
        }
        if (this.action === "UPDATE") {
          this.updateStore();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.notification.descrErrorSave"
          ),
          type: "error",
        });
      }
    },
    saveForm(evt) {
      evt.preventDefault();

      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        if (this.action === "CREATE") {
          this.createTemplate();
        }
        if (this.action === "UPDATE") {
          this.updateTemplate();
        }
        if (this.action === "CLONE") {
          this.cloneTemplate();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.notification.descrErrorSave"
          ),
          type: "error",
        });
      }
    },
    createTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        numCol: this.numCol,
        selected: this.selected,
        engine: this.engine,
        name: this.name,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
        type: "SURVEY",
      };

      this.$awn.asyncBlock(
        questionaryService.saveTab(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descSaveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.saveTab",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    templateActive(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.activateQuestionary(this.organizationId, uuid),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descActiveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.activateQuestionary",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId, uuid: uuid
            })
          });
        },
        " "
      );
    },
    deleteTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        questionaryService.deleteTemplate(uuid),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descDeleteTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.deleteTemplate",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: uuid
            })
          });
        },
        " "
      );
    },
    cloneTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        selected: this.selected,
        name: this.name,
        engine: this.engine,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        surveyService.cloneTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descCloneTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.cloneTemplate",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    updateTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        name: this.name,
        selected: this.selected,
        engine: this.engine,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        questionaryService.updateTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descRefreshTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.updateTemplate",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    listTemplate() {
      this.page = "LIST_TEMPLATE";
      this.getAllTemplates();
    },
    cleanCreate() {
      this.name = "";
      this.uuid = "";
      this.professional = localStorage.getItem("userId");
      this.clearTabs();
      this.createTab();
    },
    cleanStoreSurvey() {
      this.validatorStep2.reset();
      this.storeSurvey = {
        patientId: undefined,
        listPatientId: undefined,
        templateUuid: undefined,
        programmaticAt: undefined,
        recurrentDays: 0,
        type: undefined,
        content: "",
        name: "",
        //:TODO CAMBIAR Mapeados
        date: undefined,
        time: undefined,
        now: true,
        recurrent: false,
        patients: undefined,
        listPatients: undefined,
        template: undefined,
      };
    },
    viewStoreSurvey() {
      this.cleanStoreSurvey();
      this.action = "CREATE";
      this.$bvModal.show("modal-survey-store");
    },
    viewCreateTemplate() {
      this.cleanCreate();
      this.action = "CREATE";
      this.page = "CREATE_TEMPLATE";
    },
    viewCloneTemplate(uuid) {
      this.getTemplate(uuid);
      this.cleanCreate();
      this.action = "CLONE";
      this.page = "CREATE_TEMPLATE";
    },
    viewUpdateTemplate(uuid) {
      this.getTemplate(uuid);
      this.cleanCreate();
      this.action = "UPDATE";
      this.page = "CREATE_TEMPLATE";
    },
    viewDeleteTemplate(uuid) {
      this.deleteTemplate(uuid);
      this.page = "LIST_TEMPLATE";
    },
    goToPreviewTemplate(uuid) {
      this.$router.push({
        name: "auth.professional.survey",
        query: {
          uuid: uuid,
          mode: "PREVIEW",
        },
      });
    },
    previewTemplate(uuid) {
      this.goToPreviewTemplate(uuid);
    },
    clearTabs() {
      this.tabs = [];
    },
    createTab() {
      let tab = {
        name: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.createdTab"
        ),
        questionsList: [],
      };

      this.tabs.push(tab);
    },
    async getAllTemplates() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllTemplatesSurveyPerformance(this.professional),
        (response) => {
          if (response) {
            self.templates = response.data;

            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                value: item.uuid,
                text: item.name,
              };
              combo.push(data);
            });
            self.templatesSelect = combo;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllTemplatesSurveyPerformance",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional
            })
          });
        },
        " "
      );
    },
    //Validation form
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.errors.erName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    //Validation form modal store survey
    checkStoreName(_name) {
      const ITEM = _name.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "storeSurvey.name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.errors.erName"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkStorePatient(_patient) {
      const ITEM = _patient.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.errors.erPatient"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkStoreTemplate(_template) {
      const ITEM = _template;
      const RULE_1 = {
        expression: !ITEM,
        name: "storeSurvey.template",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.errors.erTemplate"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkStoreRecurrentDays(_item) {
      const ITEM = _item;
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "storeSurvey.recurrentDays",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.errors.erRecurrentDays"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkStoreContent(_item) {
      const ITEM = _item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "storeSurvey.content",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.errors.erContent"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    //Select organization
    backProfessionals() {
      this.showProfessional = true;
    },
    showSurveyQuestion(surveyQuestions) {
      this.surveyQuestions = surveyQuestions;
      this.$bvModal.show("modal-survey-question");
    },
    getAllByProfessional(professionalId) {
      let self = this;

      this.professionalId = professionalId;

      this.$awn.asyncBlock(
        surveyService.getAllByProfessional(professionalId),
        (response) => {
          if (response) {
            self.showProfessional = false;
            self.surveys = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.getAllByProfessional",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: professionalId
            })
          });
        },
        " "
      );
    },
    getAllByOrganizationStore() {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getAllByOrganizationStore(),
        (response) => {
          if (response) {
            self.surveys = response.data.content;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.getAllByOrganizationStore",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      organization: undefined,
      //Download
      dateStartDownload: moment().subtract(1, "months").toDate(),
      dateEndDownload: moment().toDate(),
      surveyStore: undefined,
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      //Config
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      //Store survey
      isLoadingPatients: false,
      templatesSelect: [],
      patientsSelect: [],
      listPatientsSelect: [],
      storeSurvey: {
        patientId: undefined,
        listPatientId: undefined,
        templateUuid: undefined,
        programmaticAt: undefined,
        recurrentDays: 0,
        type: undefined,
        content: "",
        name: "",
        //:TODO CAMBIAR Mapeados
        date: undefined,
        time: undefined,
        now: true,
        recurrent: false,
        patients: undefined,
        listPatients: undefined,
        template: undefined,
      },

      organizationId: localStorage.getItem("organizationId"),
      professional: localStorage.getItem("userId"),
      //templates
      numCol: "12",
      disabled: false,
      tabs: [],
      name: "",
      engine: "NORMAL",
      selected: true,
      uuid: "",
      patient: "",
      addQuestion: false,
      validatorStep1: validator,
      validatorStep2: validator,
      page: "LIST_TEMPLATE",
      engineSelect: SurveyEngine,
      templates: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: "Motor",
          value: "engine",
        },
        { text: "", value: "uuid" },
      ],
      //Tablas
      search: "",

      headersSurvey: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.headers.date"
          ),
          align: "start",
          value: "date",
        },
        { text: "", value: "id" },
      ],
      surveys: [],
      //Survey question
      headersSurveyQuestion: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.modalSurveyQuestion.headers.question"
          ),
          align: "start",
          value: "question",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.modalSurveyQuestion.headers.value"
          ),
          value: "value",
        },
      ],
      surveyQuestions: [],
      //Profesionals
      showProfessional: true,
      professionalId: "",
      headersSurveyOrganization: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Survey.professional.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: "Plantilla",
          align: "start",
          value: "template",
        },
        {
          text: "Tipo",
          align: "start",
          value: "type",
        },
        {
          text: "¿Cada cuanto se envia?",
          align: "start",
          value: "recurrentDays",
        },
        {
          text: "¿Se programo?",
          align: "start",
          value: "programmaticAt",
        },
        {
          text: "Estado",
          align: "start",
          value: "status",
        },
        { text: "", value: "id" },
      ],
      professionals: [],
    };
  },
  components: {
    VueTimepicker,
    DatePicker,
    Multiselect,
    SurveyBuilder,
    SurveyEngineBuilder,
    QuestionsView,
    "vue-dropzone": vue2Dropzone,
  },
};
</script>
